import { isArrivalOrderScheduleType } from './_consts/schedule-format';
import { RescheduleSlotsModal } from './reschedule-slots-modal.component';

import type { Appointment } from '@/types/appointments.types';
import { AppointmentType } from '@/types/enums/appointments.enum';
import { resolveAppointmentEntity } from '@/utils/formatters/appointment-entity';

interface AppointmentRescheduleSlotsModalProps {
  appointment: Appointment;
  onAppointmentUpdate?: (appointment: Partial<Appointment>) => void;
}

export function AppointmentRescheduleSlotsModal({
  appointment,
  onAppointmentUpdate,
}: AppointmentRescheduleSlotsModalProps) {
  const entity = resolveAppointmentEntity(appointment);
  const isArrivalOrder = isArrivalOrderScheduleType(appointment.scheduleType)
    || appointment.type === AppointmentType.LABORATORIAL;

  return (
    <RescheduleSlotsModal
      appointmentId={appointment.id}
      professional={{ name: entity?.name ?? '', avatarUrl: entity?.avatar }}
      isArrivalOrder={isArrivalOrder}
      onAppointmentUpdate={(slot) => {
        onAppointmentUpdate?.({
          date: slot.start,
          start: slot.start,
          end: slot.end,
          scheduleType: slot.scheduleType,
        });
      }}
    />
  );
}
